import { Link } from 'react-router-dom';

export const Footer = () => {
  return (
    <footer className="site-footer" data-testid="site-footer">
      <div className="page-container">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <h3 className="font-serif text-2xl text-[#FDFCF8] mb-4">
              Rafael Pinto
            </h3>
            <p className="footer-text max-w-xs">
              Acompanhamento cognitivo para quem procura clareza, estrutura e decisão consciente.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <span className="font-mono text-xs uppercase tracking-widest text-[#FDFCF8]/60 mb-4 block">
              Navegação
            </span>
            <nav className="flex flex-col gap-2">
              <Link 
                to="/como-trabalho" 
                className="footer-text hover:text-[#FDFCF8] transition-colors"
                data-testid="footer-como-trabalho"
              >
                Como Trabalho
              </Link>
              <Link 
                to="/acompanhamentos" 
                className="footer-text hover:text-[#FDFCF8] transition-colors"
                data-testid="footer-acompanhamentos"
              >
                Acompanhamentos
              </Link>
              <Link 
                to="/processo" 
                className="footer-text hover:text-[#FDFCF8] transition-colors"
                data-testid="footer-processo"
              >
                Processo
              </Link>
              <Link 
                to="/contacto" 
                className="footer-text hover:text-[#FDFCF8] transition-colors"
                data-testid="footer-contacto"
              >
                Conversa Inicial
              </Link>
            </nav>
          </div>

          {/* Contact */}
          <div>
            <span className="font-mono text-xs uppercase tracking-widest text-[#FDFCF8]/60 mb-4 block">
              Contacto
            </span>
            <a 
              href="mailto:contacto@orafaelpinto.com" 
              className="footer-text hover:text-[#FDFCF8] transition-colors"
              data-testid="footer-email"
            >
              contacto@orafaelpinto.com
            </a>
          </div>
        </div>

        <div className="divider bg-[#FDFCF8]/10 mt-12 mb-8" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="footer-text text-sm">
            © {new Date().getFullYear()} Rafael Pinto. Todos os direitos reservados.
          </p>
          <p className="footer-text text-sm">
            Um escritório silencioso, não um palco.
          </p>
        </div>
      </div>
    </footer>
  );
};
